import { SUPPORT_OPTIONS, SWAL_SETTINGS } from "../../../../utils/Constants";
import { POST } from "../../services/support.services";
import { useEffect, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import Swal from "sweetalert2"; // for alert
import { GET } from "../../services/support.services";

// Zod validation schema
const FormSchema = z.object({
  issueType: z
    .string()
    .min(1, "Please select an issue type")
    .refine((value) => SUPPORT_OPTIONS.includes(value), {
      message: "Please select a valid issue type",
    }),
  message: z.string().trim().min(10, "Message must be at least 10 characters long").max(1000, "Message must not exceed 1000 characters"),
});

export default function CustomerTicket() {
  const [loading, setLoading] = useState(false);
  const [supportDetails, setSupportDetails] = useState(null);

  useEffect(() => {
    GET()
      .then((response) => {
        if (response?.success) {
          console.log(response);
          setSupportDetails(response?.data?.support || null);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  }, []);

  const form = useForm({
    resolver: zodResolver(FormSchema),
    defaultValues: {
      issueType: "",
      message: "",
    },
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset,
  } = form;

  const watchAll = useWatch({ control });
  const messageLength = watchAll.message?.length || 0;

  const onSubmit = async (data) => {
    setLoading(true);

    try {
      const res = await POST({
        issueType: data.issueType?.trim(),
        message: data.message?.trim(),
      });
      console.log(res, res.data);
      if (res?.success) {
        Swal.fire({
          icon: "success",
          text: res?.message || "Ticket submitted successfully!",
          ...SWAL_SETTINGS,
        });
        reset();
      } else {
        Swal.fire({
          icon: "error",
          text: res?.data || "Failed to submit ticket",
          ...SWAL_SETTINGS,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text: error?.response?.data?.message || "Something went wrong!",
        ...SWAL_SETTINGS,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <div className="main-content">
      
      <div className="customer-part">
        <div className="card-box">
          <div className="customer-support-bg">
            <div className="text-box">
              <h3 className="h3-headline">Customer Support</h3>
              <p className="body-5">Reach out directly to our support team for real-time help.</p>
            </div>

            <div className="custem-box mt-4">
              <div className="customer-upport-box">
                <figure>
                  <div className="box-icon">
                    <svg width={30} height={30} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_6137_4431)">
                        <path
                          d="M14.9996 0.487305C18.4854 0.487305 21.7651 1.84632 24.2321 4.31348C26.5501 6.62001 27.9075 9.71718 28.0377 12.9824C29.1062 13.4953 29.8481 14.5852 29.8483 15.8486V19.2529C29.8474 19.8664 29.6694 20.4668 29.3356 20.9814C29.0197 21.4684 28.5762 21.8572 28.0553 22.1104V23.6689C28.0553 26.1049 26.0737 28.0868 23.6373 28.0869H21.6217C21.2772 28.93 20.4524 29.5116 19.5182 29.5117H17.3336C17.0344 29.5125 16.7379 29.4535 16.4615 29.3389C16.185 29.2241 15.9332 29.0554 15.7223 28.8428V28.8418C15.293 28.4138 15.0553 27.8416 15.0553 27.2334C15.0559 26.7983 15.181 26.3723 15.4156 26.0059C15.6502 25.6396 15.9847 25.3476 16.3795 25.165C16.6753 25.0272 16.9985 24.9561 17.3336 24.9561H19.5182C19.9896 24.9548 20.4496 25.1016 20.8336 25.375C21.1884 25.6276 21.4604 25.9776 21.6207 26.3809H23.6373C24.356 26.3801 25.045 26.094 25.5533 25.5859C26.0618 25.0776 26.3484 24.3879 26.3492 23.6689V22.3984C25.3373 22.2444 24.5555 21.3807 24.5553 20.3242V14.7793C24.5554 13.7362 25.3178 12.8791 26.3112 12.709C26.1088 9.9734 24.9644 7.45791 23.027 5.52051C20.8815 3.37502 18.031 2.19434 14.9996 2.19434C9.02257 2.19452 4.11414 6.83966 3.68616 12.709C4.68086 12.878 5.44489 13.735 5.44495 14.7793V20.3242C5.44428 20.8839 5.22153 21.4206 4.82581 21.8164C4.43 22.2122 3.89337 22.4348 3.33362 22.4355H3.33264C2.48928 22.4345 1.68097 22.0993 1.08459 21.5029C0.488105 20.9064 0.151912 20.0975 0.151001 19.2539V15.8496C0.151834 15.2338 0.331402 14.6312 0.667603 14.1152C0.986594 13.6257 1.43477 13.2353 1.96057 12.9834C2.25485 6.04392 7.98863 0.487491 14.9996 0.487305ZM17.2213 26.6748C17.1116 26.6969 17.0097 26.7508 16.9293 26.8311C16.8222 26.9381 16.7617 27.0839 16.7614 27.2354C16.7612 27.3097 16.7759 27.3834 16.8043 27.4521C16.8329 27.5211 16.8754 27.5841 16.9283 27.6367L17.0172 27.71C17.1106 27.7727 17.2189 27.8056 17.3326 27.8057H19.5172L19.6139 27.7979C19.7097 27.7811 19.8002 27.7396 19.8766 27.6777C19.9783 27.5953 20.0491 27.4805 20.0768 27.3525C20.0843 27.3161 20.0888 27.2759 20.0885 27.2363V27.2344C20.0885 27.1201 20.0548 27.0114 19.9928 26.9189L19.9215 26.832C19.8123 26.7224 19.6695 26.6641 19.5172 26.6641H17.3336L17.2213 26.6748ZM3.33264 14.374C2.94149 14.3746 2.56626 14.53 2.28967 14.8066C2.0131 15.0833 1.85754 15.4584 1.85706 15.8496V19.2539C1.85762 19.645 2.01311 20.0203 2.28967 20.2969C2.56626 20.5734 2.94152 20.729 3.33264 20.7295C3.55614 20.7295 3.73768 20.5474 3.73792 20.3242V14.7793C3.73785 14.556 3.55624 14.374 3.33264 14.374ZM26.5846 14.3818C26.4002 14.4199 26.2614 14.5841 26.2614 14.7793V20.3232L26.2692 20.4033C26.2848 20.4812 26.3235 20.5534 26.3805 20.6104C26.4565 20.6862 26.5592 20.7293 26.6666 20.7295L26.8121 20.7217C27.1498 20.6879 27.4675 20.5389 27.7096 20.2969C27.9862 20.0203 28.1416 19.645 28.1422 19.2539V15.8496L28.1354 15.7041C28.1015 15.3663 27.9517 15.0488 27.7096 14.8066C27.433 14.53 27.0579 14.3745 26.6666 14.374L26.5846 14.3818Z"
                          fill="white"
                          stroke="white"
                          strokeWidth="0.3"
                        />
                        <path
                          d="M19.5526 7.31641C20.387 7.31641 21.1731 7.64298 21.7645 8.23438C22.356 8.82585 22.6825 9.61231 22.6825 10.4463V16.5176C22.6815 17.3471 22.3511 18.142 21.7645 18.7285C21.178 19.3151 20.3831 19.6455 19.5536 19.6465H15.6698L13.0966 22.2061C12.9494 22.3573 12.7734 22.4775 12.579 22.5596C12.3837 22.642 12.1737 22.683 11.9618 22.6826V22.6836C11.7501 22.6838 11.5402 22.6426 11.3446 22.5615C11.1489 22.4804 10.9707 22.361 10.8212 22.2109C10.6717 22.0609 10.5539 21.8825 10.4735 21.6865C10.3931 21.4905 10.3514 21.2802 10.3524 21.0684V19.6436C9.55707 19.6187 8.79957 19.2929 8.23523 18.7285C7.64877 18.142 7.31829 17.347 7.31726 16.5176V10.4463C7.31817 9.61665 7.64859 8.82102 8.23523 8.23438C8.82187 7.64773 9.61751 7.31732 10.4471 7.31641H19.5526ZM10.3075 9.03027C9.98165 9.06287 9.67486 9.20686 9.44128 9.44043C9.17462 9.70722 9.02476 10.0691 9.02429 10.4463V16.5166C9.02474 16.8938 9.17468 17.2557 9.44128 17.5225C9.70811 17.7893 10.0708 17.94 10.4481 17.9404H11.2059C11.4322 17.9404 11.6495 18.0304 11.8094 18.1904C11.9693 18.3504 12.0594 18.5669 12.0594 18.793V20.8301L14.7167 18.1885L14.7792 18.1318C14.9307 18.0083 15.1216 17.9404 15.3192 17.9404H19.5536C19.9308 17.9399 20.2927 17.7892 20.5594 17.5225C20.8261 17.2557 20.976 16.8938 20.9764 16.5166V10.4463C20.9764 10.0677 20.8286 9.71055 20.5585 9.44043C20.2883 9.17092 19.9323 9.02348 19.5536 9.02344H10.4481L10.3075 9.03027Z"
                          fill="white"
                          stroke="white"
                          strokeWidth="0.3"
                        />
                        <path
                          d="M11.584 12.4053C12.2395 12.4053 12.7723 12.9386 12.7725 13.5928C12.7725 14.2471 12.2391 14.7803 11.584 14.7803C10.9298 14.7801 10.3965 14.2469 10.3965 13.5928C10.3966 12.9388 10.9294 12.4054 11.584 12.4053ZM15 12.4053C15.6553 12.4055 16.1874 12.9387 16.1875 13.5928C16.1875 14.2469 15.6554 14.78 15 14.7803C14.3458 14.7803 13.8125 14.247 13.8125 13.5928C13.8126 12.9387 14.3453 12.4053 15 12.4053ZM18.415 12.4053C19.07 12.4054 19.6034 12.9386 19.6035 13.5928C19.6035 14.247 19.07 14.7802 18.415 14.7803C17.7608 14.7803 17.2275 14.247 17.2275 13.5928C17.2277 12.9387 17.7604 12.4053 18.415 12.4053Z"
                          fill="white"
                          stroke="white"
                          strokeWidth="0.3"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_6137_4431">
                          <rect width={30} height={30} fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </figure>
                <figcaption>
                  <h4 className="h4-headline mt-3">Call Us</h4>
                  <a href={`tel:${supportDetails?.support_phone_number || ""}`} className="text">
                    {supportDetails?.support_phone_number}
                  </a>
                </figcaption>
              </div>
              <div className="customer-upport-box">
                <figure>
                  <div className="box-icon">
                    <svg width={30} height={30} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3.75 15C3.75 16.4774 4.04099 17.9403 4.60636 19.3052C5.17172 20.6701 6.00039 21.9103 7.04505 22.955C8.08971 23.9996 9.3299 24.8283 10.6948 25.3936C12.0597 25.959 13.5226 26.25 15 26.25C16.4774 26.25 17.9403 25.959 19.3052 25.3936C20.6701 24.8283 21.9103 23.9996 22.955 22.955C23.9996 21.9103 24.8283 20.6701 25.3936 19.3052C25.959 17.9403 26.25 16.4774 26.25 15C26.25 13.5226 25.959 12.0597 25.3936 10.6948C24.8283 9.3299 23.9996 8.08971 22.955 7.04505C21.9103 6.00039 20.6701 5.17172 19.3052 4.60636C17.9403 4.04099 16.4774 3.75 15 3.75C13.5226 3.75 12.0597 4.04099 10.6948 4.60636C9.3299 5.17172 8.08971 6.00039 7.04505 7.04505C6.00039 8.08971 5.17172 9.3299 4.60636 10.6948C4.04099 12.0597 3.75 13.5226 3.75 15Z"
                        stroke="white"
                        strokeWidth="1.7"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path d="M15 21.25V21.2625" stroke="white" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                      <path
                        d="M15 16.8755C14.977 16.4697 15.0864 16.0674 15.3119 15.7292C15.5373 15.391 15.8666 15.1353 16.25 15.0005C16.7198 14.8208 17.1416 14.5345 17.482 14.1641C17.8224 13.7938 18.0721 13.3495 18.2117 12.8662C18.3512 12.3829 18.3766 11.8738 18.2859 11.379C18.1952 10.8842 17.991 10.4173 17.6891 10.0148C17.3873 9.61243 16.9962 9.28556 16.5466 9.05997C16.097 8.83439 15.6012 8.71625 15.0982 8.71486C14.5951 8.71346 14.0987 8.82885 13.6478 9.05193C13.197 9.27502 12.804 9.59971 12.5 10.0005"
                        stroke="white"
                        strokeWidth="1.7"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </figure>
                <figcaption>
                  <h4 className="h4-headline mt-3">Email</h4>
                  <a href="mailto:support@yourapp.com" className="text">
                    {/* support@yourapp.com */}
                    {supportDetails?.support_email}
                  </a>
                </figcaption>
              </div>
            </div>

            <div className="submit-tiket mt-5">
              <h4 className="h4-headline mb-4 text-center">Submit a Ticket</h4>

              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group mb-3">
                  <label className="form-label w-100 text-left subtitle-1">
                    Issue Type <span className="text-danger">*</span>
                  </label>
                  <select {...register("issueType")} className="form-select" disabled={loading}>
                    <option value="" disabled>
                      Select your issue type
                    </option>
                    {SUPPORT_OPTIONS.map((opt, indx) => (
                      <option key={indx} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </select>
                  {errors.issueType && <p className="text-danger mt-1">{errors.issueType.message}</p>}
                </div>

                <div className="form-group mb-3">
                  <label className="form-label subtitle-1">
                    Message <span className="text-danger">*</span>
                  </label>
                  <textarea {...register("message")} className="form-control" placeholder="Describe your issue here... (minimum 10 characters)" disabled={loading} rows={4} maxLength={1000} />
                  <div className="d-flex justify-content-between mt-1">
                    <div>{errors.message && <p className="text-danger mt-1">{errors.message.message}</p>}</div>
                    <div className="text-muted small">{messageLength}/1000 characters</div>
                  </div>
                </div>

                <div className="col-md-12 text-center mt-3">
                  <button type="submit" className="btn btn-oring px-5" disabled={loading}>
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Submitting...
                      </>
                    ) : (
                      "Submit Ticket"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

    </div>
     
    </>
  );
}
